// src/com/file_of_report/TsrResultReportDef.js
// TSR결과 레포트 정의
// 운송사는 해당 없음.

import { AppWord, TableColumnType } from "../../value/AppConst";


export const TsrResultReportMeta = {
    instructions: {
        // title: 'TSR결과 Report',
        headerRowSpan: 1,
        headerRows: [],
        headerBackgroundColor: 'FFDBE6F4',
    },
    // getExtraHeaders: (records) => ValueMisc.makeDurationHeader(records),
};

// width는 8의 배수가 좋아. 40, 48, 56, 64, 72, 80, 88, 96, 104, 112, 120, 128, 136, 144, 152, 160, 168..

// TSR 결과 레포트 엑셀 컬럼 정의
export const TsrResultReportExcelColumns = [
    { id: 'planDate', width: 96, label: '일자', option:{type:TableColumnType.DATE} },
    { id: 'storeName', width: 104, label: '도착점포', option:{type:TableColumnType.TEXT} },
    { id: 'vehPlates', width: 128, label: '차량번호', option:{align: AppWord.CENTER, type:TableColumnType.TEXT} },
    {
        id: 'hocha', width: 40, label: '호차', noTotal: true,
        option:{align: AppWord.CENTER, type:TableColumnType.INTEGER}
    },
    {
        id: 'regDate', width: 152, label: 'TSR 발행시간',
        option:{align: AppWord.CENTER, type:TableColumnType.DATETIME}
    },
    { id: 'comName', width: 152, label: '운송사', option:{type:TableColumnType.TEXT} },
    {
        id: 'transfered', width: 144, label: '인수인계 완료 여부',
        option:{align: AppWord.CENTER, type:TableColumnType.BOOLEAN},
        headerBackgroundColor: 'FF77FF77',
        excel: (row, value) => value ? 'Y' : null
    },
    {
        id: 'passName', width: 96, label: '인계 운전원',
        option:{align: AppWord.CENTER, type:TableColumnType.TEXT},
        headerBackgroundColor: 'FF77FF77'
    },
    {
        id: 'passSealDate', width: 152, label: '인계일시',
        option:{align: AppWord.CENTER, type:TableColumnType.DATETIME},
        headerBackgroundColor: 'FF77FF77'
    },
    {
        id: 'autoPass', width: 112, label: '자동인계여부', 
        option:{align: AppWord.CENTER, type:TableColumnType.TEXT},
        headerBackgroundColor: 'FF77FF77',
        excel: (row, value) => value ? 'Y' : null
    },
    {
        id: 'takeUserId', width: 136, label: '인수 서명 사용자ID',
        option:{align: AppWord.CENTER, type:TableColumnType.TEXT},
        headerBackgroundColor: 'FF77FF77'
    },
    {
        id: 'takeSignature', width: 200, label: '인수 서명', option:{type:TableColumnType.TEXT},
        headerBackgroundColor: 'FF77FF77',
        excel: (row, value) => null, // 엑셀 출력시 서명 이미지는 제외. 서명 만들어지는 과정 몰라.
    },
    {
        id: 'takeSealDate', width: 152, label: '인수일시',
        option:{align: AppWord.CENTER, type:TableColumnType.DATETIME},
        headerBackgroundColor: 'FF77FF77'
    },
    {
        id: 'autoTake', width: 112, label: '자동인수여부',
        option:{align: AppWord.CENTER, type:TableColumnType.BOOLEAN},
        headerBackgroundColor: 'FF77FF77',
        excel: (row, value) => value ? 'Y' : null
    },
    {
        id: 'returnDriverCheckYn', width: 144, label: '반납집기 운전원 확인',
        option:{align: AppWord.CENTER, type:TableColumnType.TEXT},
        headerBackgroundColor: 'FFCCCCCC'
    },
    {
        id: 'returnDriverCheckDate', width: 152, label: '운전원 확인일시 ',
        option:{align: AppWord.CENTER, type:TableColumnType.DATETIME},
        headerBackgroundColor: 'FFCCCCCC'
    },
    {
        id: 'returnStoreCheckYn', width: 112, label: '접포 확인',
        option:{align: AppWord.CENTER, type:TableColumnType.TEXT},
        headerBackgroundColor: 'FFCCCCCC'
    },
    {
        id: 'returnStoreCheckDate', width: 152, label: '점포 확인일시',
        option:{align: AppWord.CENTER, type:TableColumnType.DATETIME},
        headerBackgroundColor: 'FFCCCCCC'
    },
    {
        id: 'returnDcCheckYn', width: 112, label: '센터 확인여부',
        option:{align: AppWord.CENTER, type:TableColumnType.TEXT},
        headerBackgroundColor: 'FFCCCCCC'
    },
    {
        id: 'returnDcCheckUser', width: 96, label: '센터 확인자',
        option:{align: AppWord.CENTER, type:TableColumnType.TEXT},
        headerBackgroundColor: 'FFCCCCCC'
    },
    {
        id: 'returnDcCheckDate', width: 152, label: '센터 확인일시',
        option:{align: AppWord.CENTER, type:TableColumnType.DATETIME},
        headerBackgroundColor: 'FFCCCCCC'
    },
    {
        id: 'sealNo', width: 72, label: '봉인번호',
        option:{type:TableColumnType.TEXT, align: AppWord.CENTER},
        headerBackgroundColor: 'FFFFAAAA',
        excel: (row, value) => {
            const seals = [];
            if (row.sealNo1) seals.push(row.sealNo1);
            if (row.sealNo2) seals.push(row.sealNo2);
            if (row.sealNo3) seals.push(row.sealNo3);
            return seals.join(' ');
        }
    }
];
